import { useEffect, useState } from 'react';
import algosysLogo from '../assets/algosys_logo.png';
import { BUNDLED_LOGO_ALT } from './brandingPresentation';

// ─── Brand Logo Image ─────────────────────────────────────────────────────────
// Shared brand mark for every branded surface (auth pages, sidebar).
//
// Renders the portal's custom logo only when a validated object URL is
// available; the main portal, loading, failure and post-removal states all keep
// the bundled AlgoSys platform logo. A custom image that fails to load falls
// back to the bundled asset, and a bundled asset that fails to load hides
// itself rather than leaving a broken placeholder.
export default function BrandLogoImage({ logoSrc = null, alt = null, className }) {
  const [customFailed, setCustomFailed] = useState(false);
  // A new object URL is a different image, so a previous failure must not mask it.
  useEffect(() => { setCustomFailed(false); }, [logoSrc]);

  const showCustom = Boolean(logoSrc) && !customFailed;
  return (
    <img
      src={showCustom ? logoSrc : algosysLogo}
      alt={showCustom && alt ? alt : BUNDLED_LOGO_ALT}
      className={className}
      onError={(e) => {
        if (showCustom) setCustomFailed(true);
        else e.currentTarget.style.display = 'none';
      }}
    />
  );
}
